module.exports = __webpack_public_path__ + "img/type_.32219699.png";